import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import app from "../firebase";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || (window.location.hostname === "localhost" ? "http://localhost:5000" : "");

const AuthContext = createContext();

export function useAuth() {
    return useContext(AuthContext);
}

export function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState(null);
    const [credits, setCredits] = useState(null);
    const [loading, setLoading] = useState(true);
    const auth = getAuth(app);

    const fetchCredits = useCallback(async (user) => {
        if (!user) {
            console.log("[Auth] No user found for credits fetch");
            setCredits(null);
            return;
        }
        try {
            console.log("[Auth] Fetching credits via backend for:", user.uid);
            const token = await user.getIdToken();
            const response = await axios.get(`${API_BASE_URL}/api/subscription-status`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            console.log("[Auth] Backend Response Data:", response.data);
            if (response.data) {
                const wallBal = response.data.walletBalance ?? 0;
                console.log("[Auth] Setting credits to:", wallBal);
                setCredits(wallBal);
            }
        } catch (e) {
            console.error("[Auth] Failed to fetch credits from backend:", e);
            // Default to 0 if we know the user is auth'd but the fetch failed
            setCredits(0);
        }
    }, []);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            setCurrentUser(user);
            window.currentUser = user; // Debug
            if (user) {
                document.cookie = `auth_status=logged_in; path=/; max-age=3600; SameSite=Strict`;
                await fetchCredits(user);
            } else {
                document.cookie = `auth_status=; path=/; max-age=0; SameSite=Strict`;
                setCredits(null);
                window.credits = null; // Debug
            }
            setLoading(false);
        });
        return unsubscribe;
    }, [auth, fetchCredits]);

    useEffect(() => {
        window.credits = credits; // Debug
    }, [credits]);

    const value = {
        currentUser,
        credits,
        refreshCredits: () => fetchCredits(currentUser),
        loading
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
}
